var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.9 11.3 12.1-5c1.2-.5 5.2-2.2 5.2-2.2s1.9-.7 1.7 1c-.1.7-.5 3.3-.9 6l-1.3 8.2s-.1 1.2-1 1.4c-.7.3-2.2-.7-2.5-.9-.2-.2-3.9-2.5-5.2-3.6-.4-.3-.8-.9.1-1.7 1.9-1.7 4.1-3.8 5.5-5.2.6-.6 1.2-2.1-1.4-.3l-7.4 5s-.8.5-2.4.1C3.8 13.6 2 13 2 13s-1.2-.9.9-1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.459d4a068f5a91d5daa9f4cdd548f32a.svg";
export { ForwardRef as ReactComponent };